import { render, staticRenderFns } from "./ShoppingIcon.vue?vue&type=template&id=e3ab0de2&"
import script from "./ShoppingIcon.vue?vue&type=script&lang=js&"
export * from "./ShoppingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports